export default __webpack_public_path__ + "static/media/sun_rays.3f76022f.svg";